import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton/IconButton';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { Provider as APIContextProvider } from './Context/APIContext';
import { Provider as UserContextProvider } from './Context/UserContext';
import Login from './Login';
import EditAccount from './MyPages/EditAccount/EditAccount';
import { MyPages } from './MyPages/MyPages';
import MyPayments from './MyPages/MyPayments';
import Receipt from './MyPages/MyPayments/Receipt';
import MyStorage from './MyPages/MyStorage';
import { MakhazinTheme } from './theme';
import ResetPassword from './User/ResetPassword';
const Content = (component, sx = undefined) => {
    const RouteComponent = component;
    return (React.createElement(Box, { component: "main", sx: sx },
        React.createElement(RouteComponent, null)));
};
const App = () => {
    const notistackRef = React.createRef();
    const onClickDismiss = (key) => () => {
        notistackRef.current.closeSnackbar(key);
    };
    return (React.createElement(ThemeProvider, { theme: MakhazinTheme },
        React.createElement(SnackbarProvider, { ref: notistackRef, action: key => (React.createElement(IconButton, { onClick: onClickDismiss(key) },
                React.createElement(Close, null))) },
            React.createElement(HashRouter, null,
                React.createElement(UserContextProvider, null,
                    React.createElement(APIContextProvider, null,
                        React.createElement(Routes, null,
                            React.createElement(Route, { path: "/", element: React.createElement(MyPages, null) }),
                            React.createElement(Route, { path: "/login", element: Content(Login) }),
                            React.createElement(Route, { path: "/mypages", element: Content(MyPages) }),
                            React.createElement(Route, { path: "/mypages/account", element: Content(EditAccount) }),
                            React.createElement(Route, { path: "/mypages/mystorage/:storageId/*", element: Content(MyStorage) }),
                            React.createElement(Route, { path: "/mystorage/:storageId", element: Content(MyStorage) }),
                            React.createElement(Route, { path: "/mypages/mypayments/:paymentReference", element: Content(Receipt) }),
                            React.createElement(Route, { path: "/mypages/mypayments", element: Content(MyPayments) }),
                            React.createElement(Route, { path: "/reset-password/:token", element: Content(ResetPassword) }))))))));
};
export default App;
